import React, { useState, useEffect, useContext, useMemo } from 'react';
import classNames from 'classnames';
import _ from 'lodash';
import styles from './styles.module.scss';
import Tour from 'reactour';
import { useQuery, useQueryClient } from 'react-query';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import { Button } from 'antd';
import { CustomerAccountType, CustomerLocationType } from 'common';
import { useTranslation } from 'react-i18next';
import { hiddenIntro } from 'api/profile';
import { handleErrorMessage } from 'helper';
import i18next from 'i18next';
const accentColor = '#274add';
interface IProps {
  isTourOpen: boolean;
  setIsTourOpen: (visible: boolean) => void;
  setOpenKeys: any;
}
export default function TourMenu({ isTourOpen, setIsTourOpen, setOpenKeys }: IProps) {
  const queryClient = useQueryClient();
  const { data: profile } = queryClient?.getQueryData('profile') as any;
  const { t, i18n } = useTranslation();
  const tourConfig = [
    {
      selector: '[data-tut="reactour__dashboard"]',
      content: t('react_tour.reactour__dashboard'),
    },
    // {
    //   selector: '[data-tut="reactour__profile"]',
    //   content: t('react_tour.reactour__profile'),
    // },
    // {
    //   selector: '[data-tut="reactour__personalInformation"]',
    //   content: t('react_tour.reactour__personalInformation'),
    // },
    // {
    //   selector: '[data-tut="reactour__deliveryAddressBook"]',
    //   content: t('react_tour.reactour__deliveryAddressBook'),
    // },
    // {
    //   selector: '[data-tut="reactour__emailAddress"]',
    //   content: t('react_tour.reactour__emailAddress'),
    // },
    // {
    //   selector: '[data-tut="reactour__changePassword"]',
    //   content: t('react_tour.reactour__changePassword'),
    // },
    // {
    //   selector: '[data-tut="reactour__changeAccount"]',
    //   content: profile?.accountType === CustomerAccountType.BUSINESS ? t('react_tour.reactour__deleteAccount') : t('react_tour.reactour__changeAccount'),
    // },
    // {
    //   selector: '[data-tut="reactour__privacyPolicy"]',
    //   content: t('react_tour.reactour__privacyPolicy'),
    // },
    {
      selector: '[data-tut="reactour__myOrder"]',
      content: t('react_tour.reactour__myOrder'),
    },
    {
      selector: '[data-tut="reactour__shipping"]',
      content: t('react_tour.reactour__shipping'),
    },

    {
      selector: '[data-tut="reactour__shopping"]',
      content: t('react_tour.reactour__shopping'),
    },
    {
      selector: '[data-tut="reactour__myWarehouse"]',
      content: t('react_tour.reactour__myWarehouse'),
    },
    {
      selector: '[data-tut="reactour__paymentHistory"]',
      content: t('react_tour.reactour__paymentHistory'),
    },
    {
      selector: '[data-tut="reactour__package"]',
      content: t('react_tour.reactour__package'),
    },
    // {
    //   selector: '[data-tut="reactour__reports"]',
    //   content: t('react_tour.reactour__reports'),
    // },
    // {
    //   selector: '[data-tut="reactour__toggleCollapsed"]',
    //   content: t('react_tour.reactour__toggleCollapsed'),
    // },
  ];
  const [dataTourConfig, setDataTourConfig] = useState(tourConfig);
  useEffect(() => {
    setDataTourConfig(tourConfig);
    if (
      profile?.accountType === CustomerAccountType.BUSINESS &&
      profile?.locationType === CustomerLocationType.DOMESTIC
    ) {
      const newTourConfig = tourConfig?.map((item: any, index: number) => {
        if (index === 3) {
          const newItemTour = [
            {
              selector: '[data-tut="reactour__pickupFromYourAddress"]',
              content: t('react_tour.reactour__pickupFromYourAddress'),
            },
            { ...item },
          ];
          return newItemTour;
        }
        return item;
      });
      setDataTourConfig(newTourConfig.flat());
    }
  }, [i18n.language]);
  const disableBody = (target: any) => disableBodyScroll(target);
  const enableBody = (target: any) => enableBodyScroll(target);
  const closeTour = async () => {
    setIsTourOpen(false);
    try {
      if (profile?.isVisibilityIntro) {
        await hiddenIntro();
        await queryClient.invalidateQueries('profile');
        setIsTourOpen(false);
      }
      setOpenKeys([]);
    } catch (error) {
      handleErrorMessage(error);
    }
  };

  return (
    <div key={i18n.language}>
      <Tour
        onRequestClose={closeTour}
        steps={dataTourConfig}
        isOpen={isTourOpen}
        showNavigationNumber={false}
        maskClassName="mask"
        className={styles.helper}
        rounded={5}
        maskSpace={0}
        accentColor={accentColor}
        onAfterOpen={disableBody}
        onBeforeClose={enableBody}
      />
    </div>
  );
}
